import { AxiosResponse } from "axios";
import { LeadCorretor } from "interfaces";
import { toast } from "react-toastify";

import FormatarDataLonga from "utils/formatarDataLonga";
import enviroment from "../../enviroments";
import axios from "../axiosServices";
import axiosIndentity from "../axiosServicesIdentity";

const leadsWebEnviroment =
  enviroment.URL_ADMIN === "https://sellit-app-web-pre-prod.azurewebsites.net"
    ? "leads-pre-prod"
    : "leads";

async function GetCorretores(): Promise<AxiosResponse> {
  const response = await axiosIndentity.get(
    "identity/usuario/v1/listar-usuarios-corretores"
  );
  return response;
}

async function GetLogs(
  idLeadCorretor?: string,
  params?: any
): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/app-web/logs-lead/${idLeadCorretor}`,
      params,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) {
      /* eslint-disable */
      console.log("Erro ao listar historico.");
    }
    return error;
  }
}

async function sharedLead(params: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/app-web/leads/compartilhar-lead/v1`,
    params
  );
  return response;
}

async function excludeShared(
  idLeadCompartilhado: string
): Promise<AxiosResponse> {
  const response = await axios({
    method: "delete",
    url: `${leadsWebEnviroment}/mobile/leads/excluir-compartilhamento-lead/v1/${idLeadCompartilhado}`,
  });
  return response;
}

// async function excludeListShared(params: any): Promise<AxiosResponse> {
//   const response = await axios.delete(
//     `${leadsWebEnviroment}/app-web/leads/excluir-compartilhamento-lead/v1`,
//     params
//   );
//   return response;
// }

// async function excludeListShared(params: any): Promise<AxiosResponse> {
//   const response = await axios({
//     method: "delete",
//     url: `${leadsWebEnviroment}/app-web/leads/excluir-compartilhamento-lead/v1`,
//     params: params,
//   });
//   return response;
// }

// async function excludeListShared(params: any) {
//   const toJson = localStorage.getItem("@token");
//   const datas = toJson == null ? null : JSON.parse(toJson);
//   fetch(
//     `${enviroments.BASE_URL}${leadsWebEnviroment}/app-web/leads/excluir-compartilhamento-lead/v1?cc=${enviroments.CC_MOBILE}`,
//     {
//       method: "DELETE",
//       body: JSON.stringify(params),
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + datas.token,
//         Host: "api.producthunt.com",
//       },
//     }
//   ).then((response) => response.json())
// }

async function transfLead(params: any): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/transferir/v1`,
    params
  );
  return response;
}

async function desqualificarfLead(
  idLeadCorretor: string,
  params: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/desqualificar/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function GetTasks(idLead?: string, params?: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/common/tarefas-leads/lead/v1/${idLead}`,
      params,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) console.log("Erro ao listar tarefas.");
    return error;
  }
}

async function GetTasksOfDay(
  totalItensRetorno: number,
  idsTiposTarefa?: string[] | null,
  InicioIntervaloCadastroTarefa?: string | null,
  FimIntervaloCadastroTarefa?: string | null
): Promise<AxiosResponse> {
  try {
    const mapIdTiposTarefas = idsTiposTarefa
      ?.map((item: string) => `&IdsTiposTarefa=${item}`)
      .join("");
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/common/tarefas-leads/tarefas-do-dia/v1?PaginaAtual=1&TotalItensRetorno=${totalItensRetorno}${
        mapIdTiposTarefas ? `${mapIdTiposTarefas || null}` : ""
      }${
        InicioIntervaloCadastroTarefa
          ? `&DataProgramadaInicio=${
              FormatarDataLonga(InicioIntervaloCadastroTarefa) || null
            }`
          : ""
      }${
        FimIntervaloCadastroTarefa
          ? `&DataProgramadaFim=${
              FormatarDataLonga(FimIntervaloCadastroTarefa) || null
            }`
          : ""
      }`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao listar tarefas do dia.");
    return error;
  }
}

async function GetLateTasks(
  page: number,
  totalItensRetorno: number,
  idsTiposTarefa?: string[] | null,
  InicioIntervaloCadastroTarefa?: string | null,
  FimIntervaloCadastroTarefa?: string | null
): Promise<AxiosResponse> {
  try {
    const mapIdTiposTarefas = idsTiposTarefa
      ?.map((item: string) => `&IdsTiposTarefa=${item}`)
      .join("");

    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/common/tarefas-leads/v1?StatusTarefa=1&PaginaAtual=${page}&TotalItensRetorno=${totalItensRetorno}${
        mapIdTiposTarefas ? `${mapIdTiposTarefas || null}` : ""
      }${
        InicioIntervaloCadastroTarefa
          ? `&DataProgramadaInicio=${
              FormatarDataLonga(InicioIntervaloCadastroTarefa) || null
            }`
          : ""
      }${
        FimIntervaloCadastroTarefa
          ? `&DataProgramadaFim=${
              FormatarDataLonga(FimIntervaloCadastroTarefa) || null
            }`
          : ""
      }`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao listar tarefas atrasadas.");
    return error;
  }
}

async function GetDadosLead(idLeadCorretor: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `/${leadsWebEnviroment}/commom/leads/dados-lead?idLeadCorretor=${idLeadCorretor}`
  );
  return response;
}

async function GetValidOrigin(filtro?: boolean): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/origens-leads/v1?&Filtro=${filtro ?? false}`
  );
  return response;
}
async function GetTemperature(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/temperaturas-lead/v1`
  );
  return response;
}
async function GetEtapasValida(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/leads/etapas-funil-validas/v1`
  );
  return response;
}

async function GetLeadByID(idLeadCorretor: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/dados-basicos/v1/${idLeadCorretor}`
  );
  return response;
}
async function GetAddictionalDataLead(
  idLead: string,
  tipo: number
): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/leads/telefones-emails-adicionais-lead/v1/${idLead}/${tipo}`
  );
  return response;
}

async function GetBasicData(idLead: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/dados-basicos/v1/${idLead}`
  );
  return response;
}

async function alterarLeadCorretor(
  idLeadCorretor: string,
  params: LeadCorretor
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-lead-corretor/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function alterarNome(
  idLeadCorretor: string,
  params: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-nome/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function updateTemperature(
  idLeadCorretor: string,
  params: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-temperatura-lead/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function GetPreferences(idLeadCorretor: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/preferencias/v1/${idLeadCorretor}`
  );
  return response;
}

async function GetDesqualificacao(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/motivos-desqualificacao-lead/v1`
  );
  return response;
}

// leads/mobile/motivos-desqualificacao-lead/v1

async function updatePreference(
  idLeadCorretor: string,
  params: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-preferencias/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function GetLeadByIDComplementares(
  idLead: string
): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/dados-complementares/v1/${idLead}`
  );
  return response;
}

async function GetCep(cep: string): Promise<AxiosResponse> {
  const response = await axios.get(`dadoscomum/logradouro/${cep}`);
  return response;
}
async function GetProfissoes(): Promise<AxiosResponse> {
  const response = await axios.get("dadoscomum/profissoes");
  return response;
}
async function GetRegiaoInteresse(): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/regioes-empreendimentos/v1");
  return response;
}
async function GetZone(): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/zonas-empreendimentos/v1");
  return response;
}
async function GetEnterprises(): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/empreendimentos2/v1");
  return response;
}
// canais-contato/v1

async function GetDistricts(zonas: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `locais/app-web/bairros-empreendimentos/v1/`,
    { idsZonasEmpreendimento: zonas }
  );
  return response;
}

async function GetSexo(): Promise<AxiosResponse> {
  const response = await axios.get("dadoscomum/sexos");
  return response;
}
async function GetEstadoCivil(): Promise<AxiosResponse> {
  const response = await axios.get("dadoscomum/estados-civis");
  return response;
}
async function GetRendaFamiliar(): Promise<AxiosResponse> {
  const response = await axios.get("dadoscomum/rendas-familiares");
  return response;
}
async function GetProduto(): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/empreendimentos2/v1");
  return response;
}
async function GetTorre(idEmpreendimento: string): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/torres/v1", {
    params: {
      idEmpreendimento,
    },
  });
  return response;
}
async function GetUnidades(idTorre: string): Promise<AxiosResponse> {
  const response = await axios.get("locais/mobile/unidades/v1", {
    params: {
      idTorre,
    },
  });
  return response;
}
async function GetChannelInpt(idOrigin: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/canais-contato/v1/${idOrigin}`
  );
  return response;
}

async function GetCanaisContato(idsOrigem: string[]): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/commom/leads/canais-contato/v2`,
    { IdsOrigemLead: idsOrigem }
  );
  return response;
}
async function saveLeadBasic(
  nomeLead: string,
  telefone: string,
  email: string,
  observacoes: string,
  idTemperaturaLead: string,
  idOrigemLead: string,
  idCanalContato: string,
  idEmpreendimento: string,
  idsZonasEmpreendimentos: Array<any> | null,
  idsBairrosEmpreendimentos: Array<any> | null,
  idCorretor?: string | null
): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/commom/leads/cadastro-manual/v1`,
    {
      nomeLead,
      telefone,
      email,
      observacoes,
      idTemperaturaLead,
      idOrigemLead,
      idCanalContato,
      idEmpreendimento,
      idsZonasEmpreendimentos,
      idsBairrosEmpreendimentos,
      idCorretor,
    }
  );
  return response;
}

async function GetLeads(params?: any, filters?: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/commom/leads/proprios/v1?PaginaAtual=${
        params.PaginaAtual || 1
      }&PalavrasChave=${
        params.PalavrasChave || ""
      }&TotalItensRetorno=${100}&OrdenarPorOrdemAlfabetica=${
        params.OrdenarPorOrdemAlfabetica || ""
      }${filters}`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) toast.error("Erro ao listar leads.");
    return error;
  }
}

async function GetLeadsSharedTotal(params?: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/commom/leads/leads-compartilhados/v1?PaginaAtual=${params.PaginaAtual}`,
      params,
    });
    return response;
  } catch (error: any) {
    console.log(error);
    return error;
  }
}

async function GetLeadsShared(
  params?: any,
  filters?: any
): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/commom/leads/compartilhados/v1?PaginaAtual=${
        params.PaginaAtual || 1
      }&PalavrasChave=${params.PalavrasChave || ""}&TotalItensRetorno=${
        params.TotalItensRetorno || 10
      }&OrdenarPorOrdemAlfabetica=${
        params.OrdenarPorOrdemAlfabetica || ""
      }${filters}`,
      params,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao listar leads compartilhados.");
    return error;
  }
}

async function GetLeadsTasks(idLead: string): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `${leadsWebEnviroment}/common/tarefas-leads/lead/v1/${idLead}`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401) console.log("Erro ao listar tarefas.");
    return error;
  }
}

async function GetLeadDuplicatePhone(
  name: string,
  phone: string
): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/validar-duplicidade/v1`,
    { params: { NomeLead: name, Telefone: phone } }
  );
  return response;
}

async function GetLeadDuplicateEmail(
  name: string,
  email: string
): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/commom/leads/validar-duplicidade/v1`,
    { params: { NomeLead: name, Email: email } }
  );
  return response;
}

async function GetEnterpriseType(): Promise<AxiosResponse> {
  const response = await axios.get(`locais/mobile/tipos-empreendimentos/v1`);
  return response;
}

async function GetObjetivosData(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/objetivos-compras/v1`
  );
  return response;
}

async function CreateNewTask(data: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/common/tarefas-leads/v1`,
    data
  );
  return response;
}

async function CreateConcludeTask(data: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/common/tarefas-leads/cadastrar-concluir/v1`,
    data
  );
  return response;
}

async function EditTask(
  idTarefaLead?: string,
  data?: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/common/tarefas-leads/v1/${idTarefaLead}`,
    data
  );
  return response;
}

async function EditConcluirTask(
  idTarefaLead?: string,
  data?: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/common/tarefas-leads/concluir/v1/${idTarefaLead}`,
    data
  );
  return response;
}

async function GetTiposTarefas(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/tipos-tarefas/v1`
  );
  return response;
}

async function GetConclusaoTarefas(idTipoTarefa: any): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/tipos-resultados-tarefas/v1`,
    {
      params: {
        idTipoTarefa,
      },
    }
  );
  return response;
}

async function SaveProponente(data: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `${leadsWebEnviroment}/mobile/leads/cadastrar-proponente/v1`,
    data
  );
  return response;
}
async function GetPrazos(): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/prazos-entrega-imovel/v1`
  );
  return response;
}

async function GetProponentsById(id: string): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/leads/listar-proponentes/v1/${id}`
  );
  return response;
}
async function GetRelacoesProponentsByPeople(
  tipoPessoa: string
): Promise<AxiosResponse> {
  const response = await axios.get(
    `${leadsWebEnviroment}/mobile/leads/relacoes-proponentes/v1/${tipoPessoa}`
  );
  return response;
}
async function UpdatePhoneLead(
  idLead: string,
  idLeadCorretor: string,
  telefones: Array<{
    telefone: string | null | undefined;
    telefonePrincipal: boolean;
    codigoCampoTelefone: Number;
  }>
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-telefones/v1/${idLeadCorretor}`,
    {
      idLead,
      telefones,
    }
  );
  return response;
}
async function UpdateDataComplement(
  idLeadCorretor: string,
  data: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/app-web/leads/alterar-dados-complementares/v1/${idLeadCorretor}`,
    data
  );
  return response;
}
async function UpdateEmailLead(
  idLead: string,
  idLeadCorretor: string,
  emails: Array<{
    email: string | null | undefined;
    emailPrincipal: boolean;
    codigoCampoEmail: Number;
  }>
): Promise<AxiosResponse> {
  const response = await axios.put(
    `${leadsWebEnviroment}/commom/leads/alterar-emails/v1/${idLeadCorretor}`,
    {
      idLead,
      emails,
    }
  );
  return response;
}
async function BuscaCep(cep: string): Promise<AxiosResponse> {
  const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  return response;
}

async function GetHomeIndicators(): Promise<AxiosResponse> {
  const response = await axios.get(
    `/${leadsWebEnviroment}/commom/leads/indicadores-por-corretor/v1`
  );
  return response;
}

async function GetVideosAcademia(): Promise<AxiosResponse> {
  const response = await axios.get(
    `/${leadsWebEnviroment}/commom/video-corretor/listar-por-corretor/v1?PaginaAtual=1&TotalItensRetorno=100`
  );
  return response;
}

async function alterarIdentificaLead(
  idLeadCorretor: string,
  params: any
): Promise<AxiosResponse> {
  const response = await axios.put(
    `/${leadsWebEnviroment}/commom/leads/alterar-identifica-cliente/v1/${idLeadCorretor}`,
    params
  );
  return response;
}

async function GetAniversariantes(): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `/${leadsWebEnviroment}/commom/leads/leads-aniversariantes/v1`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao listar aniversariantes do dia.");
    return error;
  }
}

async function GetNotifications(params: any): Promise<AxiosResponse> {
  try {
    const response = await axios({
      method: "get",
      url: `/notificacoes/app-web/corretor/v1?PaginaAtual=1&TotalItensRetorno=${params?.TotalItensRetorno}&AtualizaNotificacaoLida=${params?.AtualizaNotificacaoLida}`,
    });
    return response;
  } catch (error: any) {
    if (error.response.status !== 401)
      toast.error("Erro ao listar notificacoes.");
    return error;
  }
}

async function GetOutrosContatos(
  idLeadCorretor: string
): Promise<AxiosResponse> {
  const response = await axios.get(
    `/${leadsWebEnviroment}/lead/outros-contatos/v1/${idLeadCorretor}`
  );
  return response;
}

async function GetContatosRelacoes(): Promise<AxiosResponse> {
  const response = await axios.get(
    `/${leadsWebEnviroment}/contatoLead-relacoes/v1`
  );
  return response;
}

async function CreateOutrosContatos(data: any): Promise<AxiosResponse> {
  const response = await axios.post(
    `/${leadsWebEnviroment}/lead/outros-contatos/v1`,
    data
  );
  return response;
}

async function DeleteOutrosContatos(idContato: string): Promise<AxiosResponse> {
  const response = await axios.delete(
    `/${leadsWebEnviroment}/lead/outros-contatos/v1/${idContato}`
  );
  return response;
}

export default {
  GetNotifications,
  GetAniversariantes,
  GetEstadoCivil,
  GetValidOrigin,
  UpdatePhoneLead,
  UpdateEmailLead,
  saveLeadBasic,
  GetChannelInpt,
  GetCanaisContato,
  GetTemperature,
  GetEtapasValida,
  GetProfissoes,
  GetSexo,
  GetRendaFamiliar,
  GetTorre,
  GetUnidades,
  GetProduto,
  GetRegiaoInteresse,
  GetRelacoesProponentsByPeople,
  GetLeads,
  GetLeadsSharedTotal,
  GetLeadsShared,
  GetCep,
  GetAddictionalDataLead,
  GetBasicData,
  GetLeadByID,
  GetLeadByIDComplementares,
  UpdateDataComplement,
  GetProponentsById,
  GetEnterprises,
  GetEnterpriseType,
  GetObjetivosData,
  SaveProponente,
  GetPrazos,
  GetZone,
  GetDistricts,
  // ---->
  // excludeListShared,
  GetCorretores,
  updatePreference,
  GetPreferences,
  GetDesqualificacao,
  updateTemperature,
  sharedLead,
  transfLead,
  desqualificarfLead,
  GetTasks,
  GetLogs,
  GetLeadsTasks,
  GetLeadDuplicatePhone,
  GetLeadDuplicateEmail,
  alterarNome,
  BuscaCep,
  CreateNewTask,
  CreateConcludeTask,
  GetTiposTarefas,
  GetConclusaoTarefas,
  EditTask,
  EditConcluirTask,
  excludeShared,
  GetDadosLead,
  GetTasksOfDay,
  GetLateTasks,
  GetHomeIndicators,
  GetVideosAcademia,
  alterarIdentificaLead,
  alterarLeadCorretor,
  GetOutrosContatos,
  GetContatosRelacoes,
  CreateOutrosContatos,
  DeleteOutrosContatos,
};
